module.exports = __webpack_public_path__ + "img/whatsapp.e17cca7c.png";